// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"ButtonGroup_buttonGroup__1W1c2","primaryButton":"ButtonGroup_primaryButton__2oiG3","secondaryButton":"ButtonGroup_secondaryButton__3if9A"};